import i18n from '@dms/i18n';

export const BUSINESS_CASE_ONLINE_OFFER = 'BUSINESS_CASE_ONLINE_OFFER';
export const INTEREST_OFFER = 'INTEREST_OFFER';

export const automatedCommunicationModeOptions = [
  {
    value: BUSINESS_CASE_ONLINE_OFFER,
    promptName: 'businessCaseOnlineOfferPrompt',
    customerMessageId: 'ai_lead-business_case_online_offer',
    label: i18n.t('page.settings.labels.aiLeadManagementAutomatedCommunicationModeOnlineOffer'),
    description: i18n.t(
      'page.settings.labels.aiLeadManagementAutomatedCommunicationModeOnlineOfferDescription'
    ),
  },
  {
    value: INTEREST_OFFER,
    promptName: 'interestOfferPrompt',
    customerMessageId: 'ai_lead-interest_offer',
    label: i18n.t('page.settings.labels.aiLeadManagementAutomatedCommunicationModeInterestOffer'),
    description: i18n.t(
      'page.settings.labels.aiLeadManagementAutomatedCommunicationModeInterestOfferDescription'
    ),
  },
] as const;
